export const planConfig = {
  free: {
    label: "Free",
    maxCompetitors: 1,
    maxAiCallsPerDay: 10,
    historyDays: 7,
  },
  starter: {
    label: "Starter",
    maxCompetitors: 5,
    maxAiCallsPerDay: 50,
    historyDays: 30,
  },
  pro: {
    label: "Pro",
    maxCompetitors: 20,
    maxAiCallsPerDay: 200,
    historyDays: 90,
  },
  agency: {
    label: "Agency",
    maxCompetitors: 100,
    maxAiCallsPerDay: 1000,
    historyDays: 365,
  },
};

